export default {"src":"/_next/static/media/mobile-menu-icon.b62ceb72.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};